
import {
  computed, defineComponent, inject, ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// import RegistrationHeader from '@/modules/registration/components/RegistrationHeader.vue';
import AppHeader from '@/components/AppHeader.vue';
import StepTitle from '@/modules/registration/components/StepTitle.vue';
// eslint-disable-next-line import/no-cycle
import RegistrationService from '@/modules/registration/services/RegistrationService';

export default defineComponent({
  components: {
    StepTitle,
    // RegistrationHeader,
    AppHeader,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const mainStore = useMainStore();
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;

    const title = computed(() => $localize(route.meta?.title));
    const subtitle = computed(() => $localize(route.meta?.subtitle));
    const subtitleLink = computed(() => route.meta?.subtitleLink);
    const error = computed(() => route.meta?.error);
    const hideHeader = computed(() => route.meta?.hideHeader);
    const backArrow = computed(() => route.meta?.backArrow);
    const backText = computed(() => $localize(route.meta?.backText));
    const backPath = computed(() => $localize(route.meta?.backPath));
    const cancelRegistration = computed(() => route.meta?.cancelRegistration);
    const showLoginBlock = computed(() => route.meta?.showRegistrationLogin);
    const hideLoginBlock = ref(false);

    function backAction(): void {
      if (cancelRegistration.value) {
        RegistrationService.cancelRegistration();
      }
      if (backPath.value) {
        router.push(backPath.value);
      } else {
        router.back();
      }
    }

    function hideLogin() {
      hideLoginBlock.value = true;
    }

    function login() {
      router.push('/login');
    }

    return {
      title,
      mainStore,
      subtitle,
      subtitleLink,
      error,
      hideHeader,
      backArrow,
      backText,
      showLoginBlock,
      login,
      backAction,
      hideLogin,
      hideLoginBlock,
    };
  },
});
